import styled, { createGlobalStyle } from 'styled-components'
import { Table, Loader, Segment } from 'semantic-ui-react'

export const GlobalStyle = createGlobalStyle`
  th[class*="dragging-table-column"] {
    padding: 1em;
    text-align: left;
    background: #f9fafb;
    border: 1px solid rgba(34,36,38,.1);
    box-shadow: 0 10px 6px -6px #777;
    transform: scale(1.05);
    cursor: move;
    pointer-events: initial !important;

    a {
      color: #000;
    }
  }

  ${({ theme }) => theme.mediaQueries.mobile} {
    td.center {
      text-align: left;
    }
    thead {
      width: 100%;
      tr th {
        display: inline-table !important;
      }
    }
    .header-fixed {
      top: 75px;
    }
  }
`

export const TableWrapper = styled(({ fixed, ...props }) => (
  <Segment {...props} />
)).attrs({
  basic: true,
})`
  &&& {
    display: inline-block;
    padding: 0;
    margin-bottom: ${({ fixed }) => (fixed ? '3.25em' : 0)};
    margin-top: 0;
    width: 100%;

    th {
      color: #012d3e;
      font-weight: 300;
      font-size: 14px;
    }
  }
`

export const TableInnerWrapper = styled.div`
  position: relative;
  display: inline-block;
  min-width: 100%;
`

export const StyledTable = styled(Table)`
  &&& {
    table-layout: ${({ layout }) => layout};
    position: relative;
    transition: transform 0.2s linear;
    word-break: break-word;
    z-index: 0;
    border: 1px solid #dbe2e4;
    margin-bottom: 0;
    margin-top: 0;

    td {
      position: relative;
    }

    &.basic {
      border-bottom: 1px solid rgba(34, 36, 38, 0.1);
      margin-bottom: 1em;

      th,
      td {
        padding: 0.5rem !important;
      }

      td {
        border-top: 0 !important;
      }
    }

    ${({ theme }) => theme.mediaQueries.mobile} {
      border: none;

      tr {
        background: ${({ theme }) => theme.colors.backgroundColor};
        margin-bottom: 12px;
        box-shadow: none !important;
      }
    }

    ${({ layout }) =>
      layout === 'fixed' &&
      `
        th > div,
        th button,
        td,
        td div,
        td span {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
    `}

    ${props =>
      props.fixed &&
      `
    position: fixed;
    top: 0px;
    margin-top: 0;
    display: none;
    background-color: white;
    z-index: 10;

    tbody {
      visibility: hidden;
    }
  `};
  }
`

export const FilterMode = styled.div`
  max-width: 450px;
  background-color: ${({ theme }) => theme.colors.lightGrey}50;
  border: 1px solid ${({ theme }) => theme.colors.darkGrey};
  padding: 5px 0;
  border-radius: 0.28571429rem;
`

export const FilterModeSelection = styled.div<{ active?: boolean }>`
  transition: opacity 0.2s ease;
  padding: 1em;
  width: 50%;
  background-color: #fff;
  border: 1px solid
    ${({ theme, active }) =>
      active ? theme.colors.abyss : theme.colors.darkGrey};
  border-radius: 0.28571429rem;
  height: 100px;
  margin: 0 5px;
  cursor: pointer;
  opacity: ${props => (props.active ? 1 : 0.5)};

  &&& {
    * {
      cursor: pointer;
    }
  }

  &:hover {
    opacity: 1;
  }

  &:last-child {
    &&& {
      margin-left: 0;
      margin-right: 5px;
    }
  }
`

export const MoreLoaderWrapper = styled.div<{ fixed?: boolean }>`
  height: 30px;
  text-align: center;
  margin-top: ${({ fixed }) => (fixed ? '-2.5em' : 0)};
`

/* 
  If you are from the future and need to change this, please check the loaders in modals before merging your changes.👽
  The loaders in modals is used inside a dimmer and will get the wrong color.
*/
export const MoreLoader = styled(Loader)`
  &&::before {
    border-color: rgba(255, 255, 255, 0.15) !important;
  }
  &&::after {
    border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1)
      rgba(0, 0, 0, 0.1) !important;
  }
`

export const TotalCountWrapper = styled.div`
  display: inline-flex;
  padding: 4px;
  line-height: 1;
  font-size: 12px;
  background-color: rgba(42, 94, 246, 0.1);
  border: 1px solid #d4dffd;
  color: #2a5ef6;
  border-radius: 4px;
  margin-bottom: 12px;
`
